import React, { FC } from "react"
import styled from "styled-components"
import { theme } from "../../util/styles/theme"

export interface QuoteProps {
  attribution?: string
}

const Container = styled.blockquote`
  border-left: 4px solid ${theme.colors.greyDark};
  padding-left: ${theme.spacings.medium};
  margin-left: 0;
  background: ${theme.colors.greyLight};
`

const Attribution = styled.footer`
  font-style: italic;
  display: flex;
  flex-direction: row;

  &:before {
    content: "";
    display: inline-block;
    pointer-events: none;
    width: 1rem;
    height: 1px;
    background: ${theme.colors.greyDark};
    margin-right: ${theme.spacings.small};
    align-self: center;
  }
`

export const Quote: FC<QuoteProps> = ({ attribution, children }) => (
  <Container>
    {children}
    {attribution && <Attribution>{attribution}</Attribution>}
  </Container>
)
